import { useListFilterContext } from "ra-core";
import { Chip } from "@mui/material";
import { FC, useEffect } from "react";

interface QuickFilterProps {
  label: string;
  source: string;
  defaultValue?: any;
}

const QuickFilter: FC<QuickFilterProps> = ({ label, source, defaultValue }) => {
  const { displayedFilters, filterValues, setFilters, showFilter } =
    useListFilterContext();

  useEffect(() => {
    if (defaultValue !== undefined && filterValues[source] === undefined) {
      // Passando os dois argumentos explícitos para evitar erro
      setFilters(
        { ...filterValues, [source]: defaultValue },
        { ...displayedFilters, [source]: true },
      );
      showFilter(source, defaultValue);
    }
  }, [
    defaultValue,
    filterValues,
    setFilters,
    source,
    displayedFilters,
    showFilter,
  ]);

  return <Chip label={label} sx={{ mb: 1, mr: 1 }} />;
};

export default QuickFilter;
